module.exports = __webpack_public_path__ + "img/16.0ed9d460.png";